module.exports = __webpack_public_path__ + "media/images/icons/magnifying-glass-bg-e8852c8166108015bee2d81c0c5e69d2.svg";